export default __webpack_public_path__ + "static/media/carousel-isp-mdu-02.fb21790e.png";